export function maskedPhoneNumber (phoneNumber){
    return phoneNumber.replace(/\d(?=\d{3})/g, "x")
}
export function maskedLast3PhoneNumber(phoneNumber) {
    return phoneNumber.replace(/\d(?!\d{3})/g, "x")
}